<template>
  <div id="cloudServerConfig">
    <!-- 基本状态 -->
    <div class="content-area">
      <div class="top">
        <img
          class="returns"
          src="@/assets/img/backleftarrow.png"
          alt=""
          @click="goUser()"
        />
      </div>
      <div class="config-section">
        <div class="section-title-bar">
          <div class="section-title">基本状态</div>
        </div>
        <div class="section-card">
          <div class="section-content">
            <div class="label">
              实名认证<span
                class="identify-status"
                v-if="securityInfo.realNameAuthStatus"
                >已实名</span
              >
              <span class="identify-status not" v-else>未认证</span>
            </div>
            <div
              class="value go"
              v-if="!securityInfo.realNameAuthStatus"
              @click="showIdentityVerification"
            >
              去实名<van-icon
                style="font-weight: 600;"
                v-if="!securityInfo.realNameAuthStatus"
                size="14"
                name="arrow"
              />
            </div>
          </div>
          <div class="section-content">
            <div class="label">
              签约投顾服务<span
                class="identify-status"
                v-if="
                  securityInfo.investAgencySignStatus &&
                    securityInfo.investAgencySignType === '1'
                "
                >已签约</span
              >
              <span
                class="identify-status not"
                v-else-if="
                  securityInfo.investAgencySignStatus &&
                    securityInfo.investAgencySignType === '2'
                "
                >确认中</span
              >
              <span class="identify-status not" v-else>未签约</span>
            </div>
            <div
              class="value go"
              v-if="
                !securityInfo.investAgencySignStatus ||
                  securityInfo.investAgencySignType === '2'
              "
              @click="goSignAgency"
            >
              <template v-if="!securityInfo.investAgencySignStatus">
                去签约<van-icon
                  style="font-weight: 600;"
                  size="14"
                  name="arrow"
                />
              </template>
              <template v-else>
                去查看<van-icon
                  style="font-weight: 600;"
                  size="14"
                  name="arrow"
                />
              </template>
            </div>
          </div>
        </div>
      </div>

      <!-- 券商配置部分 -->
      <div class="config-section">
        <div class="section-title-bar">
          <div class="section-title">用户配置</div>
          <div class="section-title-right" @click="goToEdit()">
            <van-icon name="edit" size="16" class="edit-icon" />
            编辑配置
          </div>
        </div>
        <div
          class="section-card"
          :class="{ 'no-data': !securityInfo.securitiesSettingStatus }"
        >
          <template v-if="securityInfo.securitiesSettingStatus">
            <div class="section-content">
              <div class="label">券商名称</div>
              <div class="value">
                {{
                  (securityInfo &&
                    securityInfo.securitiesSettingVo &&
                    securityInfo.securitiesSettingVo.securitiesName) ||
                    "未设置"
                }}
              </div>
            </div>
            <div class="section-content">
              <div class="label">券商账号</div>
              <div class="value">
                {{
                  (securityInfo &&
                    securityInfo.securitiesSettingVo &&
                    securityInfo.securitiesSettingVo.securitiesUsername) ||
                    "未设置"
                }}
              </div>
            </div>
          </template>
          <template v-else>
            <div class="main-notice">
              暂无数据
            </div>
            <div class="sub-notice">
              先去创建用户配置吧
            </div>
            <van-button
              block
              round
              style="width:155px; height: 36px; margin-top: 16px;"
              color="#000000"
              @click="goToCreate"
              >创建用户配置</van-button
            >
          </template>
        </div>
      </div>

      <!-- 编程交易部分 -->
      <div class="config-section">
        <div class="section-title">编程交易</div>
        <div class="section-card">
          <div class="section-content">
            <div class="label">状态</div>
            <div class="value">
              {{
                server && server.status === "running" && !!server.runningCode
                  ? "运行中"
                  : "未运行"
              }}
            </div>
          </div>
          <div class="section-content">
            <div class="label">老师</div>
            <div class="value">
              {{ securityInfo.subscribedStrategyName || "未订阅" }}
            </div>
          </div>
          <van-button
            block
            style="border-width: 1px; border-color: #000000; margin-top: 8px; height: 36px;"
            round
            type="default"
            @click="showCodeEditor"
            >生成交易代码</van-button
          >
        </div>
      </div>
    </div>

    <!-- 校验结果弹窗 -->
    <ValidationResultPopup
      v-model="showValidationPopup"
      :title="validationTitle"
      :validation-items="validationItems"
      :confirm-text="confirmText"
      :show-cancel-button="isShowCancelButton"
      :cancel-text="cancelText"
      @confirm="handleConfirm"
      @close="handleClose"
    />
    <!-- 代码编辑器弹窗 -->
    <van-popup
      v-model="codeEditorShow"
      :style="{
        width: '270px',
        maxHeight: '438px',
        height: 'auto',
        padding: '20px 16px',
        borderRadius: '8px',
      }"
    >
      <h3
        style="
        margin-bottom: 8px;
        text-align: center;
        color: #1d2129;
        font-size: 17px;
        line-height: 24px;
        font-weight: 600;
      "
      >
        生成交易代码
      </h3>
      <van-field
        v-model="pythonCode"
        :disabled="true"
        class="code-editor-field"
        type="textarea"
        rows="10"
        placeholder="请输入Python代码"
      />
      <div>
        <van-button
          type="primary"
          color="#000000"
          style="width: 100%; height: 36px"
          :disabled="isTesting"
          round
          @click="handleTestAndDeploy()"
          >{{ isTesting ? "测试中" : "测试并部署" }}</van-button
        >
        <van-button
          type="primary"
          style="
          width: 100%;
          height: 36px;
          border: none;
          color: #86909c;
          margin-top: 8px;
          background-color: transparent;
        "
          :disabled="isTesting"
          round
          @click="codeEditorShow = false"
          >取消</van-button
        >
      </div>
    </van-popup>

    <!-- 通知弹窗 -->
    <notification-popup
      v-model="showNotificationPopup"
      :title="notificationTitle"
      @confirm="handleNotificationConfirm"
      confirm-text="我知道了"
      :content="notificationContent"
    />

    <!-- 通知弹窗 -->
    <notification-popup
      v-model="showStatusConfirmPopup"
      :close-on-click-overlay="false"
      title="状态确认"
      :show-cancel-button="true"
      @confirm="handleStatusNotificationConfirm"
      @cancel="handleStatusNotificationCancel"
      confirm-text="是"
      cancel-text="否"
      content="是否已完成签约投顾服务？"
    />

    <icp-info />
    <!-- 底部 tabBar -->
    <the-tabbar active-page="user" />
  </div>
</template>

<script>
import Vue from "vue";
import ValidationResultPopup from "@/components/ValidationResultPopup.vue";
import { Icon, Button, Switch, Toast, Popup, Dialog, Field } from "vant";
import {
  applyCloudServer,
  userInfoDetail,
  genCode,
  testPythonCode,
  getCloudServerStatus,
  updateUserSignStatus,
  deployPythonCode,
  toggleYidao,
  startupCloudServer,
  updateUserVisitStatus,
} from "@/api/theApi";
import NotificationPopup from "@/components/NotificationPopup.vue";
import IcpInfo from "@/components/IcpInfo.vue";
import TheTabbar from "@/components/theTabbar.vue";
import { getRealNameAuthUrl } from "@/api/theApi";

Vue.use(Icon);
Vue.use(Button);
Vue.use(Switch);
Vue.use(Popup);
Vue.use(Dialog);
Vue.use(Field);

export default {
  name: "CloudServerConfig",
  data() {
    return {
      username: "",
      securityInfo: {},
      showValidationPopup: false,
      validationTitle: "生成交易代码你需要",
      confirmText: "我知道了",
      validateInfo: {},
      isShowCancelButton: false,
      cancelText: "取消",
      codeEditorShow: false,
      pythonCode: "",
      isTesting: false,
      server: null,
      showNotificationPopup: false,
      notificationTitle: "签约投顾服务通知",
      notificationContent:
        "您的签约将在1-2个工作日完成，完成后将短信通知您签约状态。",
      identityVerificationShow: false,
      showStatusConfirmPopup: false,
    };
  },
  async created() {
    this.username = localStorage.getItem("username");
    this.fetchUserConfig();
    this.fetchServerStatus();
  },
  components: {
    ValidationResultPopup,
    [Popup.name]: Popup,
    [Field.name]: Field,
    NotificationPopup,
    IcpInfo,
    TheTabbar,
  },
  computed: {
    validationItems() {
      const arr = new Array(2);
      arr[0] = {
        text: "完成你的用户配置",
        status: this.securityInfo.securitiesSettingStatus ? "success" : "error",
      };
      arr[1] = {
        text: "至少订阅一位老师",
        status: !!this.securityInfo.subscribedStrategyName
          ? "success"
          : "error",
      };

      return arr;
    },
  },
  methods: {
    goUser() {
      this.$router.replace("/user");
    },
    async fetchUserConfig() {
      try {
        const username = localStorage.getItem("username");
        if (!username) {
          Toast("请先登录");
          this.$router.push("/login");
          return;
        }

        const res = await userInfoDetail(username);
        if (res.code === 20000) {
          this.securityInfo = res.data.userInfo;
          this.userVisitStatus = res.data.userInfo.userVisit;
          if (this.userVisitStatus.isFirstReturnSignPage) {
            this.showStatusConfirmPopup = true;
            await updateUserSignStatus(this.username, 2);
            await updateUserVisitStatus({ uid: this.username, type: 7 });
          }
        }
      } catch (error) {
        console.error("获取用户配置失败:", error);
        Toast("获取用户配置失败");
      }
    },
    async handleTestAndDeploy() {
      if (!this.pythonCode.trim()) {
        Toast.fail("请输入代码");
        return;
      }

      try {
        Dialog.confirm({
          title: "《金声玉亮-云主机使用协议》",
          message:
            '尊敬的用户：\n\n欢迎您选择金声玉亮（以下简称"本公司"或"我们"）提供的云主机租赁服务（以下简称"本服务"）。在您启动本服务之前，请务必仔细阅读并理解以下条款。本协议是您与本公司之间关于使用本服务的正式法律文件。\n\n服务概述\n\n本公司为您提供的是一个高性能、高可靠性的云主机租赁服务，旨在为您的应用程序、网站、开发项目等提供稳定运行环境。请注意，本公司不参与任何具体的应用程序开发或内容创建；所有部署在云主机上的应用和服务均由用户自行设计、实施、维护及优化。您应对自己部署的应用及其执行结果负全责，并承担由此产生的全部风险。\n\n用户责任与义务\n\n作为本服务的使用者，您有责任确保您部署的应用遵守适用的法律法规，并且不得用于任何非法活动。您还需保证所部署的应用不会对我们的服务器造成不合理的负担或损害。同时，您必须妥善保管自己的账号信息和密码安全，防止未授权访问。由于用户自身原因造成的损失，本公司不承担责任。\n\n数据与知识产权保护\n\n用户对其上传的所有数据、代码及材料（以下统称为"用户内容"）保留完全的所有权和相关的知识产权，包括但不限于专利、商标、版权等。本公司明确声明不获取也不主张对用户内容的任何权利或所有权，并且不会使用这些内容进行任何目的。同时，本公司不对用户内容的具体性质有所了解，也不对用户使用该内容的准确性、完整性、合法性或实用性承担任何明示或默示的责任。用户应自行确保其上传内容的合法性，并承诺对因使用该等内容而产生的任何后果承担全部法律责任。此外，对于用户内容的安全性和完整性，尤其是在发生不可抗力事件或由于用户自身错误操作引起的问题，本公司不承担任何责任。用户需自行负责保护其上传内容的安全与完整，并遵守所有适用的法律法规。\n\n风险提示\n\n尽管我们致力于提供最优质的服务，但互联网服务本身存在一定的不确定性。云主机服务可能受到不可抗力因素的影响，如自然灾害、系统故障等，这可能导致服务中断或其他影响。因此，用户应该充分认识到这些潜在的风险，并做好相应的风险管理措施。我们强烈建议用户在使用本服务前进行充分的研究和准备。\n\n免责声明\n\n本公司仅提供云主机租赁及相关技术支持，对于用户通过本服务部署的应用或进行的活动，包括但不限于性能、收益或损失，本公司不作任何形式的担保或承诺。用户应独立判断并承担所有的风险。同时，由于用户自身原因造成的任何损失，本公司也不承担赔偿责任。\n\n协议变更与终止\n\n本公司保留修改本协议的权利，并会在合理时间内通知用户有关变更的内容。如果用户不同意新的协议条款，则有权停止使用本服务。此外，若出现违反本协议规定的情况，本公司有权立即暂停或终止用户的访问权限，并采取必要的法律行动。当发生此类情况时，我们将尽可能地提前通知您，以便您有足够的时间来调整您的业务安排。\n\n法律适用与争议解决\n\n本协议的解释与执行均适用中华人民共和国法律。如果发生争议，双方应首先尝试友好协商解决；协商不成时，可以提交至本公司所在地人民法院诉讼解决。为了更好地维护您的权益，我们鼓励用户在遇到问题时及时联系我们，共同寻找解决方案。\n\n安全性保障\n\n我们重视您的信息安全，并采取了一系列技术和管理措施来保护您的个人信息和应用数据的安全。然而，请注意，互联网传输本质上并非绝对安全，用户应对此有所了解，并采取适当的安全措施，如定期更换密码、启用双重认证等，以降低潜在风险。\n\n客户支持与反馈\n\n如果您在使用过程中遇到任何问题或有任何建议，欢迎随时联系我们的客户支持团队。我们将竭诚为您提供帮助，并不断优化我们的产品和服务。您的意见对我们非常重要，有助于我们持续改进用户体验。\n\n特此声明：用户签署本用户协议，表明用户已经清楚认识使用本服务的所有相关风险，并愿意自行承担使用过程中可能发生的一切风险和损失。',
          confirmButtonText: "同意",
          confirmButtonColor: "#f2826a",
          cancelButtonText: "取消",
        })
          .then(async () => {
            try {
              const testRes = await testPythonCode({
                username: this.username,
                code: this.pythonCode,
              });
              console.log("测试成功:", testRes);
            } catch (e) {
              console.log("测试失败:", e);
            }
            const deployRes = await this.deployCode();
            console.log("部署结果", deployRes);
            Toast.success("部署成功");
          })
          .catch(() => {
            console.log("用户取消操作");
          });
      } catch (error) {
        console.error("操作失败:", error);
        Toast.fail("操作失败，请稍后重试");
        this.isTesting = false;
      }
    },
    goSignAgency() {
      if (
        !this.securityInfo.investAgencySignStatus ||
        this.securityInfo.investAgencySignType === "2"
      ) {
        this.userVisitStatus.isFirstReturnSignPage = false;
        this.showNotificationPopup = true;
      }
    },
    async handleStatusNotificationConfirm() {
      await updateUserSignStatus(this.username, 2);
      this.securityInfo.investAgencySignStatus = true;
      this.securityInfo.investAgencySignType = "2";
      this.showStatusConfirmPopup = false;
      this.showNotificationPopup = true;
    },
    async handleStatusNotificationCancel() {
      await updateUserSignStatus(this.username, 1);
      this.securityInfo.investAgencySignStatus = false;
      this.showStatusConfirmPopup = false;
    },
    async handleNotificationConfirm() {
      this.showNotificationPopup = false;
      if (this.userVisitStatus.isFirstReturnSignPage) {
        this.showNotificationPopup = false;
      } else {
        await updateUserVisitStatus({uid: this.username, type: 8});
        location.href = this.securityInfo.investAgencyURL;
      }
    },
    async deployCode() {
      try {
        Toast.loading({
          message: "正在部署...",
          forbidClick: true,
        });
        console.log("开始部署代码:", {
          username: this.username,
          cloudServerId: this.server.id,
          codeLength: this.pythonCode.length,
        });

        if (this.server && this.server.status !== "running") {
          await startupCloudServer(this.username);
        }

        const res = await deployPythonCode({
          username: this.username,
          code: this.pythonCode,
          cloudServerId: this.server.id,
        });
        console.log("部署响应:", res);

        if (res.code === 200) {
          // 部署成功后启用自动交易
          this.fetchServerStatus();
          const toggleRes = await toggleYidao(1);
          console.log("toggleRes:", toggleRes);
          if (toggleRes.data === "success") {
            Toast.success("部署成功并已启动");
            this.codeEditorShow = false;
            this.yidaochecked = true;
          } else {
            Toast.fail("部署成功但启动失败");
          }
        } else {
          Toast.fail(res.msg || "部署失败");
          console.error("部署失败:", res.msg);
        }
      } catch (error) {
        console.error("部署过程异常:", error);
        Toast.fail("部署失败，请稍后重试");
      }
    },
    async handleIdentitySubmit(data) {
      // 处理实名认证提交
      console.log("实名认证提交:", data);
      // this.isIdentityVerified = true;
      this.identityVerificationShow = false;
      await this.fetchUserConfig();
    },
    handleIdentityCancel() {
      // 处理取消实名认证
      console.log("取消实名认证");
      this.identityVerificationShow = false;
    },
    handleIdentityClose() {
      // 处理关闭实名认证弹窗
      console.log("关闭实名认证弹窗");
      this.identityVerificationShow = false;
    },
    async showIdentityVerification() {
      const res = await getRealNameAuthUrl(this.username);
      if (res.code === 20000) {
        window.location.href = res.data;
      } else {
        Toast.fail(res.msg || "获取实名认证URL失败， 请稍后再试");
      }
    },
    async fetchServerStatus() {
      try {
        const res = await getCloudServerStatus(this.username);
        if (res.code === 200) {
          // 假设后端返回的状态为 "running" 或 "stopped"
          this.server = res.data;
        }
      } catch (error) {
        console.error("获取云主机状态失败:", error);
      }
    },

    async showCodeEditor() {
      await this.fetchUserConfig();
      const errors = this.validationItems.filter(
        (item) => item.status === "error"
      );
      if (errors.length > 1) {
        this.confirmText = "我知道了";
        this.showValidationPopup = true;
        return;
      } else if (errors.length === 1) {
        if (errors[0].text === "完成你的用户配置") {
          this.confirmText = "去用户配置";
        } else {
          this.confirmText = "去订阅";
        }
        this.isShowCancelButton = true;
        this.cancelText = "以后再说";
        this.showValidationPopup = true;
        return;
      }
      if (!this.server) {
        const res = await applyCloudServer(this.username);
        if (res.code === 200) {
          this.server = res.data;
        } else {
          Toast.fail(res.msg || "申请云主机失败");
        }
      }
      if (
        !this.securityInfo.investAgencySignStatus &&
        !this.securityInfo.realNameAuthStatus
      ) {
        await Dialog.confirm({
          title: "提示",
          message:
            "请尽快完成签约投顾服务和实名认证后可自动部署，目前代码仅供预览",
          confirmButtonText: "确认",
          showCancelButton: false,
        });
      } else if (!this.securityInfo.investAgencySignStatus) {
        await Dialog.confirm({
          title: "提示",
          message: "请尽快完成签约投顾服务后可自动部署，目前代码仅供预览",
          confirmButtonText: "确认",
          showCancelButton: false,
        });
      } else if (!this.securityInfo.realNameAuthStatus) {
        await Dialog.confirm({
          title: "提示",
          message: "请尽快完成实名认证后可自动部署，目前代码仅供预览",
          confirmButtonText: "确认",
          showCancelButton: false,
        });
      }

      const res = await genCode(this.username);
      if (res.code === 200) {
        this.pythonCode = res.data;
        this.codeEditorShow = true;
      } else {
        Toast.fail(res.msg || "代码生成失败，请联系管理员。");
      }
    },
    handleClose() {
      this.showValidationPopup = false;
    },
    handleConfirm() {
      this.showValidationPopup = false;
      if (this.confirmText === "去用户配置") {
        this.$router.push("/userConfig");
      } else if (this.confirmText === "去订阅") {
        this.$router.push("/strategylist");
      }
    },
    goToEdit() {
      this.$router.push("/userConfig");
    },
    goToCreate() {
      if (
        this.securityInfo.investAgencySignStatus &&
        this.securityInfo.realNameAuthStatus
      ) {
        this.$router.push("/userConfig");
      } else if (
        !this.securityInfo.investAgencySignStatus &&
        !this.securityInfo.realNameAuthStatus
      ) {
        Dialog.confirm({
          title: "提示",
          message: "请尽快完成签约投顾服务和实名认证后可生成交易代码",
          confirmButtonText: "确认",
          showCancelButton: false,
        })
          .then(() => {})
          .finally(() => {
            this.$router.push("/userConfig");
          });
      } else if (!this.securityInfo.investAgencySignStatus) {
        Dialog.confirm({
          title: "提示",
          message: "请尽快完成签约投顾服务后可生成交易代码",
          confirmButtonText: "确认",
          showCancelButton: false,
        })
          .then(() => {})
          .finally(() => {
            this.$router.push("/userConfig");
          });
      } else if (!this.securityInfo.realNameAuthStatus) {
        Dialog.confirm({
          title: "提示",
          message: "请尽快完成实名认证后可生成交易代码",
          confirmButtonText: "确认",
          showCancelButton: false,
        })
          .then(() => {})
          .finally(() => {
            this.$router.push("/userConfig");
          });
      }
    },
  },
};
</script>

<style lang="less" scoped>
#cloudServerConfig {
  box-sizing: border-box;
  min-height: calc(100dvh);
  padding: 20px 16px 50px;
  background-color: #f5f5f5;

  .content-area {
    min-height: calc(100dvh - 128px);
    .top {
      .returns {
        display: block;
        width: 24px;
        height: 24px;
        margin-bottom: 16px;
      }
    }
  }
}

.config-section {
  margin-bottom: 16px;

  .section-title-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .section-title-right {
    display: flex;
    align-items: center;
    color: #8c5800;
    gap: 4px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 14px;
    line-height: 1.5;
  }

  .section-title {
    font-size: 16px;
    font-weight: 500;
  }

  .section-card {
    margin-top: 12px;
    background-color: #ffffff;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
    &.no-data {
      padding: 40px 16px;
      align-items: center;
    }

    .main-notice {
      font-family: PingFangSC-Medium;
      font-weight: 600;
      font-size: 16px;
      text-align: center;
      color: #000000;
    }

    .sub-notice {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #00000080;
    }
  }

  .section-content {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &.empty {
      opacity: 0.4;
    }

    .label {
      color: #000000;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      line-height: 1.5;

      .identify-status {
        margin-left: 4px;
        padding: 2px 6px;
        background: #1ab73a1a;
        color: #074a1599;
        font-size: 12px;
        border-radius: 2px;

        &.not {
          color: #0000001a;
          background: #e6e6e6;
          color: #00000099;
        }
      }
    }

    .value {
      color: #00000080;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      line-height: 1.5;

      &.go {
        display: flex;
        align-items: center;
        color: #8c5800;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 14px;
        line-height: 1.5;
      }
    }
  }

  .switch-wrapper {
    display: flex;
    align-items: center;
  }
}

.code-editor-field {
  margin-bottom: 8px;
  padding: 0;
  border-bottom: none;
  color: #4e5969;
  font-size: 15px;
  line-height: 22px;
  &::after {
    display: none;
  }
}

.footer-info {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  text-align: center;
  font-size: 12px;
  color: #999;
  line-height: 1.5;
}
</style>
